module.exports = __webpack_public_path__ + "fonts/Ki.2a5ff834.ttf";